<template>
        <section class="my-lg-5 my-4">
            <div class="container">
                <div class="my-lg-5 my-4">
                    <img src="https://cdn.studiesweekly.com/store/StudentEditionSpreadImage.png" class="img-fluid w-100">
                </div>

                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center">
                            <h5>New Generation of Student Materials</h5>
                            <p>Say goodbye to your old-fashioned textbooks. Studies Weekly's highly engaging, student-centric content brings learning to life for every child.</p>
                            <!-- <button type="button" class="btn btn-outline-primary">Preview Publication</button> -->
                        </div>
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3">
                            <img src="https://cdn.studiesweekly.com/store/productpage-ext_10.jpg" class="img-fluid w-100">
                        </div>
                    </div>
                </div>
                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3">
                            <img src="https://cdn.studiesweekly.com/store/TeachersEdition-K.png" class="img-fluid w-100">
                        </div>
                        <div class="col-lg-6 align-self-center">
                            <h5>Completely New Teacher Edition</h5>
                            <p>Written by teachers, for teachers, with sequenced and scaffolded instruction and differentiated strategies.</p>
                            <a href='https://national.studiesweekly.com/' class='btn btn-outline-primary'>Learn More</a>
                            <!-- <button type="button" class="btn btn-outline-primary">Preview Publication</button> -->
                        </div>
                    </div>
                </div>
                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-5 align-self-center">
                            <h5>Designed to Encourage Inquiry</h5>
                            <p>Our new product includes four weekly lessons that guide students in devloping inquiries, examining sources, evaulating and analyzing evidence, communicating conclusions, and taking action.</p>
                            <a href='https://national.studiesweekly.com/' class='btn btn-outline-primary'>Learn More</a>
                            <!-- <button type="button" class="btn btn-outline-primary">Preview Publication</button> -->
                        </div>
                        <div class="col-lg-7 align-self-center mb-lg-0 mb-3">
                            <img src="https://cdn.studiesweekly.com/store/Inquiry.png" class="img-fluid w-100">
                        </div>
                    </div>
                </div>
                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3" style='text-align:center'>
                            <img src="https://cdn.studiesweekly.com/store/Well-Being.png" class="img-fluid w-50" style='margin: 0 auto;'>
                        </div>
                        <div class="col-lg-6 align-self-center">
                            <h5>Introduces a Well-Being Resource</h5>
                            <p>A stand-alone <strong>K-5 curriculum</strong> with 32 articles and teacher lesson plans ensures that <strong>all students and educators</strong> thrive physically, socially, mentally, and academically.</p>
                            <!-- <button type="button" class="btn btn-outline-primary">Preview Publication</button> -->
                        </div>
                    </div>
                </div>
                <div class="my-lg-5 my-4">

                    <h4>Powerful Online Tools</h4>

                    <div>
                        <b-tabs content-class="mt-3">
                            <b-tab title="Online, Customizable Assessments" active>
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="auto" src="https://www.youtube.com/embed/JrkUZscxHkE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                            <b-tab title="Related Media">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="autto" src="https://www.youtube.com/embed/KkaTaxSa54Q" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                            <b-tab title="Annotative Text and Highlighting Tool">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe width="100%" height="autto" src="https://www.youtube.com/embed/_Bnn4uMVp7I" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['block'],
    components: {

    },
    methods: {
        showModal (modal) {
            this.$bvModal.show(modal)
        },
        closeModal (modal) {
            this.$bvModal.hide(modal)
        }
    },
    mounted () {

    }
}
</script>
